<div class="main-container">

    <div class="container-auth">
        <div class="texto-auth">
            <h1 class="titulo-auth">Página não encontrada</h1>
            <p class="justificativa-auth">
                O conteúdo que você está tentando acessar não existe ou foi removido.
                <br>
                Verifique o endereço informado ou retorne à navegação principal.
            </p>
            <button type="button" [routerLink]="rotaRetorno" class="btn btn-return-home mt-5">Ir para a página inicial</button>
        </div>

        <img src="assets/images/auth-404.jpg" class="imagem-auth"
            alt="Ilustração indicando que a página solicitada não foi encontrada">

    </div>
</div>
